import angular from 'angular';
import translation from '../translation';
import tenantConfig from '../tenant-config';
import notification from '../notification';
import service from './service';

const app = angular.module('klRatePlan', [notification, translation, tenantConfig]);

service(app);

export default app.name;
